'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

export const CourseDetailsMenu = () => {
  const [activeTab, setActiveTab] = useState('about-course');
  const t = useTranslations();

  const menus = [
    { name: t('course-details.menu.about'), path: 'about-course' },
    { name: t('course-details.menu.modules'), path: 'course-modules' },
    { name: t('course-details.menu.instructors'), path: 'course-instructor' },
    { name: t('course-details.menu.faq'), path: 'faq' },
  ];

  return (
    <div className="hidden sticky top-21 z-10 w-full bg-white lg:inline-flex">
      <div className="flex overflow-x-auto gap-4 w-full">
        {menus.map(menu => (
          <a
            key={menu.path}
            href={`#${menu.path}`}
            className={`
            text-base font-semibold px-3 py-2 rounded-[6px]
            ${activeTab === menu.path ? 'border-b-2 border-primary-500 rounded-none text-primary-500 ' : 'text-gray-500'}
          `}
            onClick={() => setActiveTab(menu.path)}
          >
            {menu.name}
          </a>
        ))}
      </div>
    </div>
  );
};
